export default __webpack_public_path__ + "static/media/DraftIcon.c55d1cbb.svg";